import { render, staticRenderFns } from "./Attending.vue?vue&type=template&id=56b1f425&scoped=true"
import script from "./Attending.vue?vue&type=script&lang=js"
export * from "./Attending.vue?vue&type=script&lang=js"
import style0 from "./Attending.vue?vue&type=style&index=0&id=56b1f425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1f425",
  null
  
)

export default component.exports